import { AccessRequestResponse } from "@api";
import { StyledTableCell } from "@components";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
} from "@material-ui/core";
import React from "react";
import { Application } from "@store/types";
import { AdditionalFormModal } from "../../../../request/steps/summary/views/summary/additional-form-modal";
import { Ballot as BallotIcon } from "@material-ui/icons";
import Hooks from "@hooks";
import { getAdditionalFormKeyFromApplication } from "../../../../request/utils";

const AdditionalForm: React.FC<{
  access: AccessRequestResponse;
  application?: Application;
  onClose: () => void;
  open: boolean;
}> = (props) => {
  const values = React.useMemo(() => {
    const formName = getAdditionalFormKeyFromApplication(
      props.application?.additionalForm
    );
    const formValues = props.access.additionalForm;

    return formName && formValues ? formValues[formName] : undefined;
  }, [props.access, props.application]);

  return props.application ? (
    <AdditionalFormModal
      application={props.application}
      onCancel={props.onClose}
      onSubmit={() => {}}
      open={props.open}
      values={values}
      readonly={true}
    />
  ) : null;
};

interface Props {
  user: string | null;
  status: string | null;
  accessRequests: AccessRequestResponse[];
}

export const RequestsDetailTable: React.FC<Props> = ({
  user,
  status,
  accessRequests,
}) => {
  const applications = Hooks.useApplications();
  const [additionalFormOpen, setAdditionalFormOpen] = React.useState(false);

  return applications.value ? (
    <TableContainer component={Box} bgcolor="white">
      <Table>
        <TableHead>
          <TableRow>
            <StyledTableCell>User</StyledTableCell>
            <StyledTableCell>Name</StyledTableCell>
            <StyledTableCell>Device Type</StyledTableCell>
            <StyledTableCell>Application</StyledTableCell>
            <StyledTableCell>Role</StyledTableCell>
            <StyledTableCell>Environment</StyledTableCell>
            <StyledTableCell>Status</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {accessRequests.map(
            (access: AccessRequestResponse, index: number) => (
              <React.Fragment key={index}>
                <TableRow>
                  <TableCell>{user}</TableCell>
                  <TableCell>
                    <Box display="flex" alignItems="center">
                      <Box pr={0.5}>{access.subCategory}</Box>
                      {access.additionalForm ? (
                        <IconButton
                          size="small"
                          onClick={() => {
                            setAdditionalFormOpen(true);
                          }}
                        >
                          <BallotIcon fontSize="small" />
                        </IconButton>
                      ) : null}
                    </Box>
                  </TableCell>
                  <TableCell>{access.deviceType}</TableCell>
                  <TableCell>{access.appName || "-"}</TableCell>
                  <TableCell>{access.role}</TableCell>
                  <TableCell>{access.environment}</TableCell>
                  <TableCell>{status}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="right">
                    <Typography variant="body2">
                      <span>
                        <b>Access Details</b>
                      </span>
                    </Typography>
                  </TableCell>
                  <TableCell colSpan={6}>
                    <Typography variant="body2">
                      {access.accessJustification}
                    </Typography>
                  </TableCell>
                </TableRow>
                <AdditionalForm
                  access={access}
                  application={(applications.value || []).find(
                    (application) => application.name === access.subCategory
                  )}
                  onClose={() => setAdditionalFormOpen(false)}
                  open={additionalFormOpen}
                />
              </React.Fragment>
            )
          )}
        </TableBody>
      </Table>
    </TableContainer>
  ) : null;
};
